export default __webpack_public_path__ + "static/media/Sacramento-Regular.8e499a8c.ttf";